import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Honest FulPhilment'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
